import { render, staticRenderFns } from "./plsWechat.vue?vue&type=template&id=513dcd14&scoped=true"
import script from "./plsWechat.vue?vue&type=script&lang=js"
export * from "./plsWechat.vue?vue&type=script&lang=js"
import style0 from "./plsWechat.vue?vue&type=style&index=0&id=513dcd14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513dcd14",
  null
  
)

export default component.exports